import React, { useContext } from "react"

export interface AdminAuthContextValue {
  getAzureAdAuthority: () => string
  getAzureAdScopes: () => string[]
  triggerAuthPage: (force?: boolean) => void
}

const createNotInitializedError = (functionName: string) => () => {
  throw new Error(
    `AdminAuthContext: ${functionName} was called, but no provider is present.`,
  )
}

export const AdminAuthContext = React.createContext<AdminAuthContextValue>({
  getAzureAdAuthority: createNotInitializedError("getAzureAdAuthority"),
  getAzureAdScopes: createNotInitializedError("getAzureAdScopes"),
  triggerAuthPage: createNotInitializedError("triggerAuthPage"),
})

export const useAdminAuthContext = (): AdminAuthContextValue =>
  useContext(AdminAuthContext)
